import { IEvent } from "~app/common/services/cqs/event.service";
import { SetLeveransradKvantitetCommand } from "~app/features/justera-leveransplan/common/commands/SetLeveransradKvantitetCommand";

export class SetLeveransradKvantitetEnqueued implements IEvent {
    $type: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "SetLeveransradKvantitetEnqueued";

    constructor(readonly enqueued: SetLeveransradKvantitetCommand) {
        this.$type = SetLeveransradKvantitetEnqueued.type;
    }
}
